<template>
  <div>
    <vue-headful
      title="Parent Onboarding - Add Child | Gradelyng"
      description="Description goes here"
    />
    <div class="onboarding-section">
      <!-- CLOSE TRIGGER -->
      <div class="pageClose dialogDismiss" @click="goToFeeds" v-if="false">
        <button
          type="button"
          class="close_dialog cls_lg transparent_bg"
        ></button>
      </div>
      <!-- CLOSE TRIGGER -->

      <div class="container onboarding-wrapper">
        <div class="setup-container">
          <!-- SETUP BOX -->
          <div class="setup-box white rounded-20">
            <!-- SETUP TOP -->
            <div class="w-100 setup-top">
              <!-- ONBOARDING FORM COMPONENT -->
              <NewChildForm @toFeedPage="goToFeeds"></NewChildForm>
              <!-- ONBOARDING FORM COMPONENT -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bgColorSetter } from "@/scripts/utilities";
import NewChildForm from "@/components/parentsComps/onboarding/NewChildForm.vue";

export default {
  name: "OnboardingOne",

  components: {
    NewChildForm,
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters(["getSelectedChildID"]),
  },

  mounted() {
    localStorage.setItem("now_show_back_to_school_banner", true);
    bgColorSetter("#f0f0f0");
  },

  methods: {
    goToFeeds() {
      // console.log("student id added>>>>", this.getSelectedChildID);
      this.$router.push({
        name: "ParentFeeds",
        params: { id: this.getSelectedChildID },
      });
    },
  },
};
</script>

<style lang="scss">
.onboarding-section {
  .onboarding-bottom {
    margin: 50px auto 60px;
  }
}
</style>
